import { WaitlistForm } from "../components/site/WaitlistForm";
import { useRefCapture } from "./Landing";

export default function Join() {
  useRefCapture();
  return (
    <div className="relative min-h-[80vh] py-16 md:py-24" data-testid="join-page">
      <div className="absolute inset-0 grid-bg opacity-40" />
      <div className="relative max-w-2xl mx-auto px-5"><WaitlistForm /></div>
    </div>
  );
}
